import _ from 'lodash';
import { useRouter } from 'next/router';
import qs from 'qs';
import { useEffect } from 'react';

import useUser from 'hooks/use-user';

type ExternalUserDetailsQueryParams = {
  birthDay: string;
  birthMonth: string;
  birthYear: string;
  email: string;
  id: string;
  firstName: string;
  lastName: string;
  phone: string;
};

type QueryParams = {
  externalUserDetails: ExternalUserDetailsQueryParams;
};

/*
 * Extract & use external user details for Plus checkouts
 */
export function useExternalUserDetails(): void {
  const router = useRouter();
  const user = useUser();

  useEffect(() => {
    if (router.isReady) {
      const queryParams = router.asPath.split('?')[1];
      const parsedQueryParams = qs.parse(queryParams) as QueryParams;

      if (!_.isUndefined(parsedQueryParams.externalUserDetails)) {
        user.setUserDetailsFromExternalSource({
          birthDay: parsedQueryParams.externalUserDetails.birthDay,
          birthMonth: parsedQueryParams.externalUserDetails.birthMonth,
          birthYear: parsedQueryParams.externalUserDetails.birthYear,
          email: parsedQueryParams.externalUserDetails.email,
          externalUserId: parsedQueryParams.externalUserDetails.id,
          firstName: parsedQueryParams.externalUserDetails.firstName,
          lastName: parsedQueryParams.externalUserDetails.lastName,
          phone: parsedQueryParams.externalUserDetails.phone,
        });
      }
    }
  }, [router.isReady, router.asPath, user]);
}
